import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Box from "@mui/joy/Box";
import Typography from "@mui/joy/Typography";
import DescriptionIcon from "@mui/icons-material/Description";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AspectRatio from "@mui/joy/AspectRatio";
import Button from "@mui/joy/Button";
import PublicIcon from "@mui/icons-material/Public";
import LayersIcon from "@mui/icons-material/Layers";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import ScheduleIcon from "@mui/icons-material/Schedule";
import AvatarGroup from "@mui/joy/AvatarGroup";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";
import Avatar from "@mui/joy/Avatar";
import Chip from "@mui/joy/Chip";
import HikingIcon from "@mui/icons-material/Hiking";
import Alert from "@mui/joy/Alert";
import LandscapeIcon from "@mui/icons-material/Landscape";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import LaunchIcon from "@mui/icons-material/Launch";
import ChatIcon from "@mui/icons-material/Chat";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import IconButton from "@mui/joy/IconButton";
import FacebookIcon from "@mui/icons-material/Facebook";
import XIcon from "@mui/icons-material/X";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkIcon from "@mui/icons-material/Link";
import { useNavigate } from "react-router-dom";

export default function DetalleAventura() {
  let [aventura, setaventura] = React.useState({});
  let [usuarios, setUsuarios] = React.useState();
  let [boton, setBoton] = React.useState({
    color: "success",
    contenido: "Unirme",
  });
  let [loading, setLoading] = React.useState(false);
  let fechaFormato = new Date(aventura.fecha);
  let [notificacion, setNotificacion] = React.useState({
    contenido: "",
    color: "",
    decorator: "",
    estado: false,
  });
  let [botonchat, setBotonChat] = React.useState(false);

  const { id } = useParams();
  let urlAventura = `https://amigoutdoors.com/share/aventura/${id}`;
  let url = process.env.REACT_APP_FRONTEND_URL;
  let linkimagen = process.env.REACT_APP_DOSPACES;
  let navigate = useNavigate();

  useEffect(() => {
    try {
      /* OBTENER BEARER TOKEN */
      let token = localStorage.getItem("token");

      /* OBTENER BEARER TOKEN */

      let informacionobtenida = [];
      let getaventura = async () => {
        let informacion = await axios.get(`${url}/api/aventuras/vermas`, {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            id: id,
          },
        });
        console.log(informacion.data[0]);
        setaventura(informacion.data[0]);

        /* Obtener usuarios inscritos */

        let getInscritos = await axios.get(
          `${url}/api/aventura/usuarios-inscritos`,
          {
            params: { id: informacion.data[0].actividad_id },
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        console.log(getInscritos);
        setUsuarios(getInscritos.data);
        /* Obtener usuarios inscritos */

        try {
          let buscarusuario = getInscritos.data.usuariosinscritos.filter(
            (x) => x.id_usuario === getInscritos.data.usuario_actual
          );
          if (
            getInscritos.data.usuario_actual === buscarusuario[0].id_usuario
          ) {
            setBoton(() => ({
              color: "danger",
              contenido: "Abandonar",
            }));
            setBotonChat(true);
          }
        } catch (err) {
          console.log(
            "Tenemos un error al obtener los usuarios inscritos: " + err
          );
        }
      };
      getaventura();
    } catch (err) {
      /*  console.log("Tenemos un error al ver el detalle de la aventura: " + err); */
    }
  }, []);

  let BodyIzquierda = () => {
    return (
      <Box>
        <Box sx={{ display: { md: "block", xs: "none" } }}>
          <AspectRatio
            ratio="2"
            sx={{
              borderRadius: { md: 5 },
              borderBottomLeftRadius: { xs: 5 },
              borderBottomRightRadius: { xs: 5 },
            }}
          >
            <img
              src={`${process.env.REACT_APP_DOSPACES}/uploads/${aventura.imagen}`}
              alt=""
            />
          </AspectRatio>
        </Box>
        <Box sx={{ display: { xs: "block", md: "none" } }}>
          <AspectRatio
            ratio="1"
            sx={{
              borderRadius: { md: 5 },
              borderBottomLeftRadius: { xs: 5 },
              borderBottomRightRadius: { xs: 5 },
            }}
          >
            <img
              src={`${process.env.REACT_APP_DOSPACES}/uploads/${aventura.imagen}`}
              alt=""
            />
          </AspectRatio>
        </Box>
        <Box sx={{ marginTop: { md: 3, xs: 1.5 }, padding: { md: 0, xs: 1 } }}>
          <Typography level="title-lg">{aventura.titulo}</Typography>
        </Box>
        <Box
          sx={{
            display: { xs: "flex", md: "inherit" },
            justifyContent: { xs: "center", md: "inherit" },
          }}
        >
          <Box
            sx={{
              backgroundColor: "#f0f4f8",
              borderRadius: 5,
              marginTop: { md: 2, xs: 1 },
              padding: { md: 3, xs: 1.5 },
              display: "grid",
              gap: 1,
              width: { xs: "85vw", md: "inherit" },
            }}
          >
            <Typography
              level="title-sm"
              sx={{
                display: "flex",
                gap: 0.5,
                alignItems: "center",
                alignContent: "center",
              }}
            >
              <DescriptionIcon fontSize="inherit" />
              Descripción de la Aventura
            </Typography>
            <Typography level="body-sm">{aventura.descripcion}</Typography>
          </Box>
        </Box>

        <Box
          sx={{
            display: { md: "flex", xs: "block" },
            marginTop: 3,
            justifyContent: "space-between",
            padding: { md: "inherit", xs: 1 },
          }}
        >
          <Box>
            <Typography
              level="title-sm"
              sx={{
                display: "flex",
                gap: 0.5,
                alignItems: "center",
                alignContent: "center",
              }}
            >
              <LocationOnIcon fontSize="inherit" />
              Punto de encuentro
            </Typography>
            <Typography level="body-sm">
              {aventura.punto_de_encuentro}
            </Typography>
          </Box>
          <Box>
            <Button
              color="neutral"
              variant="soft"
              size="md"
              onClick={() => {
                window.open(
                  `https://www.google.com/maps?q=${aventura.latitud},${aventura.longitud}`
                );
              }}
              sx={{ marginTop: { md: "inherit", xs: 2 }, width: "100%" }}
            >
              Ver en Maps
            </Button>
          </Box>
        </Box>
        <Box
          sx={{
            marginTop: 3,
            display: "flex",
            width: "100%",
            gap: 1,
            padding: { md: "inherit", xs: 1 },
          }}
        >
          <Box sx={{ width: "50%" }}>
            <Typography
              level="title-sm"
              sx={{
                display: "flex",
                gap: 0.5,
                alignItems: "center",
                alignContent: "center",
              }}
            >
              <ScheduleIcon fontSize="inherit" />
              Fecha de Ejecución
            </Typography>
            <Typography level="body-sm">
              {fechaFormato.toLocaleDateString("es-ES", {
                day: "2-digit",
                month: "long",
                year: "numeric",
                timeZone: "UTC",
              })}
            </Typography>
          </Box>
          <Box sx={{ width: "50%" }}>
            <Typography
              level="title-sm"
              sx={{
                display: "flex",
                gap: 0.5,
                alignItems: "center",
                alignContent: "center",
              }}
            >
              <PublicIcon fontSize="inherit" />
              Ubicación
            </Typography>
            <Typography level="body-sm">
              {aventura.pais}, {aventura.ciudad}
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            marginTop: 3,
            display: "flex",
            width: "100%",
            gap: 1,
            padding: { md: "inherit", xs: 1 },
          }}
        >
          <Box sx={{ width: "50%" }}>
            <Typography
              level="title-sm"
              sx={{
                display: "flex",
                gap: 0.5,
                alignItems: "center",
                alignContent: "center",
              }}
            >
              <LayersIcon fontSize="inherit" />
              Categoría
            </Typography>
            <Typography level="body-sm">{aventura.categoria}</Typography>
          </Box>
          <Box sx={{ width: "50%" }}>
            <Typography
              level="title-sm"
              sx={{
                display: "flex",
                gap: 0.5,
                alignItems: "center",
                alignContent: "center",
              }}
            >
              <PriorityHighIcon fontSize="inherit" />
              Nivel
            </Typography>
            <Typography level="body-sm">{aventura.nivel}</Typography>
          </Box>
        </Box>
      </Box>
    );
  };

  let BodyDerecha = ({ postular, loading, chat }) => {
    return (
      <Box>
        <Box
          sx={{
            display: "grid",
            gap: 1,
            marginTop: { md: "inherit", xs: 2 },
            padding: { md: "inherit", xs: 1 },
          }}
        >
          <Typography
            level="title-lg"
            sx={{
              display: "flex",
              gap: 0.5,
              alignItems: "center",
              alignContent: "center",
            }}
          >
            Organizado por
          </Typography>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              backgroundColor: "#f0f4f8",
              borderRadius: 5,
              padding: { md: 5, xs: 1 },
              marginTop: { md: "inherit", xs: 1 },
            }}
          >
            <Box>
              <Avatar
                src={`${process.env.REACT_APP_DOSPACES}/uploads/${aventura.foto_de_perfil}`}
                size="lg"
                sx={{
                  "--Avatar-size": "100px",
                  border: 2,
                  borderColor: "white",
                  cursor: "pointer",
                  transition: "0.2s",

                  "& img": {
                    transition: "0.2s",
                  },

                  "&:hover img": {
                    filter: "brightness(0.6)",
                  },
                }}
              />
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  alignContent: "center",
                  justifyContent: "center",
                }}
              ></Box>
            </Box>
            <Box>
              <Typography
                level="title-md"
                endDecorator={
                  <Chip color="success" variant="soft" size="sm" sx={{}}>
                    Organizador
                  </Chip>
                }
              >
                {aventura.nombre}
              </Typography>
              <Typography level="body-xs">
                {aventura.descripcion_perfil}
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <Box
              sx={{
                display: "flex",
                background: "#fff8e1",
                borderRadius: 2,
                padding: 1.5,
                gap: 1,
                alignItems: "center",
                alignContent: "center",
              }}
            >
              <ReportProblemIcon fontSize="small" sx={{ color: "#6b7280" }} />
              <Typography level="body-xs" sx={{ color: "#6b7280" }}>
                Esta salida es organizada por un miembro de la comunidad.
                AmigOutdoors no es responsable por su ejecución ni condiciones.
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box sx={{ marginTop: 3 }}>
          <Typography
            level="title-lg"
            sx={{
              display: "flex",
              gap: 0.5,
              alignItems: "center",
              alignContent: "center",
              padding: { md: "inherit", xs: 1 },
            }}
          >
            Participantes
          </Typography>
          <Box
            sx={{
              marginTop: 3,
              display: { md: "flex", xs: "none" },
              gap: 1,
              backgroundColor: "#f0f4f8",
              borderRadius: 5,
              marginTop: 2,
              padding: { md: 3, xs: 1 },
            }}
          >
            <Box sx={{ width: "100%" }}>
              <Typography
                level="title-sm"
                sx={{
                  display: "flex",
                  gap: 0.5,
                  alignItems: "center",
                  alignContent: "center",
                }}
              >
                <EmojiPeopleIcon fontSize="inherit" />
                Asistirán
              </Typography>
              <Typography level="body-sm">
                {usuarios ? usuarios.usuariosinscritos.length : null}
              </Typography>
            </Box>
            <AvatarGroup>{usuarios ? inscritos() : null}</AvatarGroup>
            <Button
              variant="soft"
              color={boton.color}
              startDecorator={<HikingIcon />}
              onClick={() => {
                postular();
              }}
              loading={loading}
            >
              {boton.contenido}
            </Button>
          </Box>
          <Box
            sx={{
              display: { md: "none", xs: "grid" },
              justifyContent: "center",
              alignItems: "center",
              alignContent: "center",
              width: "100%",
            }}
          >
            <Box
              sx={{
                marginTop: 3,
                display: { md: "none", xs: "grid" },
                gap: 1,
                backgroundColor: "#f0f4f8",
                borderRadius: 5,
                marginTop: 2,
                padding: 1,
                width: "90vw",
              }}
            >
              <Box sx={{ display: "flex" }}>
                <Box sx={{ width: "100%" }}>
                  <Typography
                    level="title-sm"
                    sx={{
                      display: "flex",
                      gap: 0.5,
                      alignItems: "center",
                      alignContent: "center",
                    }}
                  >
                    <EmojiPeopleIcon fontSize="inherit" />
                    Asistirán
                  </Typography>
                  <Typography level="body-sm">
                    {usuarios ? usuarios.usuariosinscritos.length : null}
                  </Typography>
                </Box>
                <AvatarGroup>{usuarios ? inscritos() : null}</AvatarGroup>
              </Box>

              <Button
                variant="soft"
                color={boton.color}
                startDecorator={<HikingIcon />}
                onClick={() => {
                  postular();
                }}
                loading={loading}
                sx={{ width: "100%", marginTop: 2 }}
              >
                {boton.contenido}
              </Button>
            </Box>
          </Box>
          {chat ? (
            <Box
              sx={{
                display: "grid",
                marginTop: 2,
                gap: 1,
                padding: { md: "inherit", xs: 1 },
              }}
            >
              <Typography
                level="title-lg"
                sx={{
                  display: "flex",
                  gap: 0.5,
                  alignItems: "center",
                  alignContent: "center",
                }}
              >
                Chat Grupal
              </Typography>
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    backgroundColor: "#f0f4f8",
                    borderRadius: 5,
                    padding: { md: 3, xs: 1.5 },
                    justifyContent: "space-between",
                  }}
                >
                  <Box>
                    <Typography
                      level="title-sm"
                      sx={{
                        display: "flex",
                        gap: 0.5,
                        alignItems: "center",
                        alignContent: "center",
                      }}
                    >
                      <ChatIcon fontSize="inherit" />
                      Grupo Activo
                    </Typography>
                    <Typography level="body-sm">
                      {aventura.nombre} y{" "}
                      {usuarios ? usuarios.usuariosinscritos.length - 1 : null}{" "}
                      más están coordinando la salida
                    </Typography>
                  </Box>
                  <Box>
                    <Button
                      variant="soft"
                      color={"success"}
                      size={"sm"}
                      endDecorator={<LaunchIcon />}
                      onClick={() => {
                        navigate("/amigos");
                      }}
                    >
                      Ir al Chat
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Box>
          ) : null}
          <Box
            sx={{
              marginTop: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
              }}
            >
              <IconButton
                variant="plain"
                onClick={() => {
                  window.open(
                    `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                      urlAventura
                    )}`,
                    "_blank"
                  );
                }}
              >
                <FacebookIcon />
              </IconButton>
              <IconButton
                variant="plain"
                onClick={() => {
                  window.open(
                    `https://wa.me/?text=${encodeURIComponent(
                      `¡Únete a la aventura ${aventura.titulo}! Descúbrela aquí: ${urlAventura} ¡No te la pierdas!`
                    )}`,
                    "_blank"
                  );
                }}
              >
                <WhatsAppIcon />
              </IconButton>{" "}
              <IconButton
                variant="plain"
                onClick={() => {
                  window.open(
                    `https://twitter.com/intent/tweet?text=${encodeURIComponent(
                      `¡Únete a la aventura ${aventura.titulo}! Descúbrela aquí: ${urlAventura} ¡No te la pierdas!`
                    )}`,
                    "_blank"
                  );
                }}
              >
                <XIcon />
              </IconButton>
              <IconButton
                variant="plain"
                onClick={() => {
                  window.open(
                    `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
                      urlAventura
                    )}`,
                    "_blank"
                  );
                }}
              >
                <LinkedInIcon />
              </IconButton>
              <IconButton
                variant="plain"
                onClick={() => {
                  navigator.clipboard.writeText(urlAventura);
                  setNotificacion((valoranterior) => ({
                    ...valoranterior,
                    contenido: "Enlace Copiado",
                    color: "success",
                    estado: true,
                    decorator: <LinkIcon />,
                  }));

                  setTimeout(() => {
                    setNotificacion((valoranterior) => ({
                      ...valoranterior,
                      estado: false,
                    }));
                  }, 2000);
                }}
              >
                <LinkIcon />
              </IconButton>
            </Box>
            <Box sx={{ padding: { md: "inherit", xs: 1 } }}>
              <Typography
                level="title-sm"
                sx={{
                  display: "flex",
                  gap: 0.5,
                  alignItems: "center",
                  alignContent: "center",
                  justifyContent: "center",
                  marginTop: 1,
                  textAlign: { md: "inherit", xs: "center" },
                }}
              >
                Envía esta aventura a alguien que debería venir contigo
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    );
  };

  /*  REFRESCAR USUARIOS INSCRITOS FRONTEND */

  let refrescarUsuarios = () => {
    try {
      /* OBTENER BEARER TOKEN */
      let token = localStorage.getItem("token");

      /* OBTENER BEARER TOKEN */

      let getUsuariosAventura = async () => {
        let usuariosInscritos = await axios.get(
          `${url}/api/aventura/usuarios-inscritos`,
          {
            params: { id: aventura.actividad_id },
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        /*   console.log(usuariosInscritos.data); */
        setUsuarios(usuariosInscritos.data);
        /*  setBotonEstado(false); */
        setNotificacion((valoranterior) => ({
          ...valoranterior,
          estado: false,
        }));
        try {
          let buscarusuario = usuariosInscritos.data.usuariosinscritos.filter(
            (x) => x.id_usuario === usuariosInscritos.data.usuario_actual
          );
          /* Valida que el usuario actual este inscrito o no, para cambiar el estado del boton */
          if (
            usuariosInscritos.data.usuario_actual ===
            buscarusuario[0].id_usuario
          ) {
            setBoton((valoranterior) => ({
              ...valoranterior,
              color: "danger",
              contenido: "Abandonar",
            }));
            setBotonChat(true);
          }
        } catch (err) {
          setBoton((valoranterior) => ({
            ...valoranterior,
            color: "success",
            contenido: "Unirme",
          }));
          setBotonChat(false);
        }
      };
      getUsuariosAventura();
    } catch (err) {
      console.log(err);
    }
  };

  /*  REFRESCAR USUARIOS INSCRITOS FRONTEND */

  let postular = async () => {
    try {
      setLoading(true);
      let datosAventura = new FormData();
      datosAventura.append("titulo_actividad", aventura.titulo_actividad);
      datosAventura.append("id_actividad", aventura.id_actividad);

      /* OBTENER BEARER TOKEN */
      let token = localStorage.getItem("token");

      /* OBTENER BEARER TOKEN */
      let enviarpostulacion = await axios.post(
        `${url}/api/aventura/unirse-salirse`,
        datosAventura, // Si no necesitas enviar datos en el cuerpo
        { headers: { Authorization: `Bearer ${token}` } } // Objeto de configuración con headers
      );
      if (enviarpostulacion.data.type === "join") {
        console.log("dentro");
        setNotificacion((valoranterior) => ({
          ...valoranterior,
          contenido: "¡Listo, estas dentro! Prepara tu equipo",
          color: "success",
          estado: true,
          decorator: <LandscapeIcon />,
        }));
      }
      if (enviarpostulacion.data.type === "delete") {
        console.log("fuera");
        setNotificacion((valoranterior) => ({
          ...valoranterior,
          contenido: "Haz abandonado, nos vemos en la próxima aventura",
          color: "danger",
          estado: true,
          decorator: <MeetingRoomIcon />,
        }));
      }

      setTimeout(() => {
        refrescarUsuarios();
        setLoading(false);
      }, 2000);
    } catch (err) {
      console.log("tenemos un error " + err);
    }
  };

  function inscritos() {
    return (
      <Box sx={{ width: "50%", display: "flex" }}>
        {usuarios.usuariosinscritos.map((x, index) => {
          if (index > 5) {
            return null;
          } else if (index < 5) {
            return (
              <Avatar
                src={`${process.env.REACT_APP_DOSPACES}/uploads/${x.foto_de_perfil}`}
                size="md"
              />
            );
          }
        })}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: { md: "flex", xs: "grid" },
        width: "100vw",
        marginLeft: { md: 10, xs: 0 },
        height: "100vh",
      }}
    >
      <Box
        sx={{ width: { md: "44%", xs: "100vw" }, padding: { md: 5, xs: 0 } }}
      >
        <BodyIzquierda />
      </Box>

      <Box
        sx={{ width: { md: "40%", xs: "100vw" }, padding: { md: 5, xs: 0 } }}
      >
        {notificacion.estado && (
          <Alert
            variant="soft"
            className="notificacion"
            color={notificacion.color}
            startDecorator={notificacion.decorator}
          >
            {notificacion.contenido}
          </Alert>
        )}
        <BodyDerecha postular={postular} loading={loading} chat={botonchat} />
      </Box>
    </Box>
  );
}
